// extracted by mini-css-extract-plugin
export default {"container":"ReadMoreModal_container__tszdL","list":"ReadMoreModal_list__cA5g2","title":"ReadMoreModal_title__KpvDO","btn":"ReadMoreModal_btn__Wkx9s"};